'use client'
import {Toaster} from 'sonner'

const ToastContainer = () => {
    return (
        <Toaster theme='dark' position='bottom-left' richColors closeButton visibleToasts={6} duration={5000}/>
    )
}

export default ToastContainer